<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师管理</Breadcrumb-item>
        <Breadcrumb-item>在职老师</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form label-position="top" :show-message="false">
        <Row :gutter="16">
          <i-col :xs="24" :sm="12" :md="8" :lg="4">
            <Form-item label="外教运营">
              <Select
                v-model.number="queryParam.studyAdviserId"
                placeholder="全部"
                @on-change="search"
                clearable>
                <Option
                  v-for="item in studyAdviserList"
                  :value="item.id"
                  :key="item.id">
                  {{ item.nickname }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="8" :lg="4">
            <Form-item label="类型">
              <Select
                v-model.number="queryParam.category"
                placeholder="全部"
                @on-change="search"
                clearable>
                <Option
                  v-for="item in teacherCategoryList"
                  :value="item.code"
                  :key="item.code">
                  {{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="8" :lg="4">
            <Form-item label="是否分配外教运营">
              <Select
                v-model.number="queryParam.isStudyAdviser"
                placeholder="全部"
                @on-change="search"
                clearable>
                <Option v-for="item in $constant.isStudyAdviser"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="8" :lg="4">
            <Form-item label="口音">
              <Select
                v-model.number="queryParam.accent"
                placeholder="全部"
                @on-change="search"
                clearable>
                <Option v-for="item in $constant.accent"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="8" :lg="4">
            <Form-item label="性别">
              <Select
                v-model.number="queryParam.sex"
                placeholder="全部"
                @on-change="search"
                clearable>
                <Option v-for="item in $constant.sex"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="8" :lg="4">
            <Form-item label="老师">
              <Input
                name="name"
                placeholder="ID/姓名"
                v-model="queryParam.tchKey">
              </Input>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="8" :lg="4">
            <Form-item label="登录账号">
              <Input
                name="account"
                placeholder="支持模糊搜索"
                v-model="queryParam.account">
              </Input>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="8" :lg="4">
            <Form-item label="授课类型">
              <Select
                v-model.number="queryParam.tchType"
                placeholder="全部"
                @on-change="search"
                clearable>
                <Option value="-1">全部</Option>
                <Option v-for="item in $constant.tchType"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="8" :lg="4">
            <Form-item label="来源">
              <Select
                v-model.number="queryParam.channel"
                placeholder="全部"
                @on-change="search"
                clearable>
                <Option
                  v-for="item in $constant.tchChannel"
                  :value="item.code"
                  :key="item.code">
                  {{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="8" :lg="4">
            <Form-item label="注册渠道">
              <Select v-model="queryParam.regFrom" placeholder="全部" clearable @on-change="search" transfer>
                <Option v-for="item in channelOptions" :value="item.param" :key="item.id">{{ item.status === 0 ? (item.name + '（停用）') : item.name }}</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="24" :md="16" :lg="8">
            <Form-item label="开课时间">
              <DatePicker @on-change="atimeDateChange" format="yyyy-MM-dd" type="daterange"
                          placement="bottom-start" placeholder="选择日期范围" style="width: 100%"></DatePicker>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="24" :md="16" :lg="8">
            <Form-item label="注册时间">
              <DatePicker @on-change="createDateChange" format="yyyy-MM-dd" type="daterange"
                          clearable placement="bottom-start" placeholder="选择日期范围" style="width: 100%"></DatePicker>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="8" :lg="4">
            <Form-item label="HR">
              <Select v-model="queryParam.hr" placeholder="全部"
                      @on-change="search" clearable transfer>
                <Option v-for="item in $constant.hrList"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="8" :lg="4">
            <Form-item label="推荐人">
              <Input name="inviteRemark" placeholder="支持模糊搜索"
                     v-model="queryParam.inviteRemark"></Input>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="8" :lg="4">
            <Form-item label="优秀外教">
              <Select v-model="queryParam.excellent" placeholder="全部" @on-change="search" clearable>
                <Option v-for="item in excellentOptions" :value="item" :key="item">{{ item }}</Option>
              </Select>
            </Form-item>
          </i-col>
        </Row>
      </Form>
      <div class="search-actions">
        <Button
          type="primary"
          :loading="searchLoading"
          :disabled="searchLoading"
          icon="search"
          @click="search">
          搜索
        </Button>
        <Button type="primary" @click="onAssignAdviser">分配外教运营</Button>
        <Button
          :loading="exportLoading"
          :disabled="exportLoading"
          type="primary"
          @click="exportData">
          导出
        </Button>
      </div>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" :reloadWithPage="reloadWithPage"
          listUrl="/tchList/normal-list"
          :params="queryParam" :onLoading="onLoading" @on-selection-change="selectionChange"></List>

    <AssignTchStudyAdviserModal :successCallback="searchWithPage" :tchList="selectionTch"
                                v-model="showAssignTchStudyAdviserModal"></AssignTchStudyAdviserModal>

    <tch-info-modal :value="showTchInfoModal" @on-close="showTchInfoModal=false" :tchId="tchId"
                    :successCallback="searchWithPage"></tch-info-modal>
    <EditDingDingModal :tchId="tchId" :value="showEditDingModal" @on-close="closeEditDingModal"
                       :successCallback="searchWithPage"></EditDingDingModal>
    <TeachersDingTalkModal :tchId="tchId" :value="showTeacherDingTalkModal" @on-close="closeTeacherDingTalkModal"
                           :successCallback="searchWithPage"></TeachersDingTalkModal>

    <send-email-modal :visible="showEmailModal" @on-close="showEmailModal=false" :tchId="emailTchId"
                      :tchName="emailTchName" :successCallback="search"></send-email-modal>
    <Modal width="800"
           v-model="showTchChangeModal"
           title="外教运营分配记录">
      <Table :columns="tchChangeStatusColumn" :data="tchChangeStatusList"></Table>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>
<script>
import TchCancelOpenedTimeModal from './TchCancelOpenedTimeModal.vue'
import TchAddOpenedTimeModal from './TchAddOpenedTimeModal.vue'
import TchEditOpenedTimeModal from './TchEditOpenedTimeModal.vue'
import TchCancelRandomOpenedTimeModal from './TchCancelRandomOpenedTimeModal.vue'
import TchAddRandomOpenedTimeModal from './TchAddRandomOpenedTimeModal.vue'
import TchLeaveModal from './TchLeaveModal.vue'
import TchLeaveOfficeModal from './TchLeaveOfficeModal.vue'
import AssignTchStudyAdviserModal from './modal/AssignTchStudyAdviserModal.vue'
import TchInsertModal from './TchInsertModal.vue'
import TchInfoModal from './modal/TchInfoModal.vue'
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
import AllTeachersLeaveModal from './AllTchLeaveModal'
import EditDingDingModal from './modal/EditDingDingModal'
import TeachersDingTalkModal from './modal/TeachersDingTalkModal'
import SubstituteTchSelect from '@/components/common/SubstituteTchSelect'
import SendEmailModal from './modal/SendEmailModal.vue'

export default {
  components: {
    SendEmailModal,
    TeachersDingTalkModal,
    EditDingDingModal,
    TchCancelOpenedTimeModal,
    TchAddOpenedTimeModal,
    TchEditOpenedTimeModal,
    TchCancelRandomOpenedTimeModal,
    TchAddRandomOpenedTimeModal,
    TchLeaveModal,
    TchLeaveOfficeModal,
    AssignTchStudyAdviserModal,
    TchInsertModal,
    AllTeachersLeaveModal,
    TchInfoModal,
    SubstituteTchSelect
  },
  name: 'tchNormalList',
  data: function () {
    let $moment = this.$moment
    let $constant = this.$constant
    return {
      reviewParam: {
        ids: '',
        remark: ''
      },
      showEmailModal: false,
      emailTchId: null,
      emailTchName: '',
      activityList: [],
      substituteList: [],
      lsnBeginTime: '',
      loadingReject: false,
      showRejectModal: false,
      showBatchReviewModal: false,
      rejectParam: {
        id: '',
        remark: ''
      },
      searchLoading: false,
      rankScoreSeq: 0,
      exportLoading: false,
      reload: 0,
      reloadWithPage: 0,
      showTchChangeModal: false,
      tchChangeStatusList: [],
      tchChangeStatusColumn: [
        {
          title: '原来的外教运营',
          render: (h, params) => {
            return h('span', params.row.oldNickname || '')
          }
        },
        {
          title: '新的外教运营',
          render: (h, params) => {
            return h('span', params.row.newNickname || '')
          }
        },
        {
          title: '操作人',
          key: 'adminNickname'
        },
        {
          title: '操作时间',
          width: 170,
          render: (h, params) => {
            let createTime = params.row.createTime
            return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
          }
        }
      ],
      showTchInfoModal: false,
      tchId: null,
      queryParam: {
        tchKey: '',
        sex: '',
        accent: '',
        mobile: '',
        nickname: '',
        startTimeDate: '',
        endTimeDate: '',
        tchType: '',
        channel: '',
        regFrom: '',
        excellent: '',
        startCreateDate: '',
        endCreateDate: '',
      },
      channelOptions: [],
      excellentOptions: ['是', '否'],
      showEditDingModal: false,
      showTeacherDingTalkModal: false,
      tchInsertModal: false,
      teacherCategoryList: $constant.teacherCategory.filter(item => [1, 2, 3].includes(item.code)),
      studyAdviserList: [],
      showTchAddOpenedTimeModal: false,
      showTchEditOpenedTimeModal: false,
      showTchCancelOpenedTimeModal: false,
      showTchAddRandomOpenedTimeModal: false,
      showCancelRandomOpenedTimeModal: false,
      showTchLeaveModal: false,
      showTchLeaveOfficeModal: false,
      showAssignTchStudyAdviserModal: false,
      showAllTeacherLeaveModel: false,
      selectionTch: [],
      showSelectTch: false,
      substituteTchId: '',
      selectTchParam: {
        lessonTime: '',
        name: '',
        tchStudyAdviser: '', // 学习导师
        adviser: '', // 课程顾问
        openedId: '',
        substituteTchId: ''
      },
      title: [
        {
          title: '老师ID',
          width: 80,
          fixed: 'left',
          align: 'center',
          key: 'id'
        },
        {
          title: '老师昵称',
          width: 150,
          fixed: 'left',
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return renderTchNameWithScore(h, {
              text: row.firstName + row.lastName,
              score: row.monthRankScore,
              onClick: () => this.openTchInfoModal(row.id)
            })
          }
        },
        {
          title: 'Full Name',
          width: 200,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              props: {
                value: row.fullName,
                placeholder: 'Full Name'
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.fullName) {
                    row.fullName = newValue
                    this.updateTchDirect({tchForm: {tchId: row.id, fullName: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.fullName) {
                    row.fullName = value
                    this.updateTchDirect({tchForm: {tchId: row.id, fullName: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '真实国籍',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let countryCode = row.nationality ? row.nationality.toLowerCase() : ''
            return h('div', {
              style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }
            }, [
              countryCode ? h('span', {
                attrs: {
                  class: `fi fi-${countryCode}`
                },
                style: {
                  marginRight: '8px',
                  fontSize: '18px'
                }
              }) : null,
              h('Input', {
                attrs: {
                  title: row.nationality || ''  // 添加 title 属性显示完整内容
                },
                props: {
                  value: row.nationality,
                  placeholder: '真实国籍'
                },
                on: {
                  'on-blur': (event) => {
                    const newValue = event.target.value
                    if (newValue !== row.nationality) {
                      row.nationality = newValue
                      this.updateTchDirect({tchForm: {tchId: row.id, nationality: newValue}})
                    }
                  },
                  'on-enter': (value) => {
                    if (value !== row.nationality) {
                      row.nationality = value
                      this.updateTchDirect({tchForm: {tchId: row.id, nationality: value}})
                    }
                  }
                }
              })
            ])
          }
        },
        {
          title: '现居地',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.address || ''  // 添加title属性显示完整内容
              },
              props: {
                value: row.address,
                placeholder: 'address',
                type: 'textarea',
                autosize: {
                  minRows: 1,
                  maxRows: 3
                }
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.address) {
                    row.address = newValue
                    this.updateTchDirect({tchInfo: {tchId: row.id, address: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.address) {
                    row.address = value
                    this.updateTchDirect({tchInfo: {tchId: row.id, address: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '风险地区',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let level = Number(params.row.riskRegionLevel)
            if (level === 1) {
              return h('Tag', { props: { color: 'red' } }, '禁止')
            }
            if (level === 2) {
              return h('Tag', { props: { color: 'orange' } }, '极高风险')
            }
            if (level === 3) {
              return h('Tag', { props: { color: '#d48806' } }, '高风险')
            }
            return h('span')
          }
        },
        {
          title: '外教等级',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.tchLevel || ''  // 添加title属性显示完整内容
              },
              props: {
                value: row.tchLevel,
                placeholder: '等级'
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.tchLevel) {
                    row.tchLevel = newValue
                    this.updateTchDirect({tchForm: {tchId: row.id, tchLevel: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.tchLevel) {
                    row.tchLevel = value
                    this.updateTchDirect({tchForm: {tchId: row.id, tchLevel: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '外教运营',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let name = row.studyAdviserNickname
            if (!name) {
              return h('span', '')
            }
            return h('a', {
              on: {
                click: () => {
                  this.onTchChangeStatusList(row.id)
                }
              }
            }, name)
          }
        },
        {
          title: 'HR',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let options = this.$constant.hrList.slice()
            if (row.hr && !options.some(item => item.code === row.hr)) {
              options = [{code: row.hr, text: row.hr}].concat(options)
            }
            return h('Select', {
              props: {
                value: row.hr,
                transfer: true,
                clearable: true
              },
              on: {
                'on-change': (value) => {
                  const newValue = value || ''
                  if (newValue !== (row.hr || '')) {
                    row.hr = newValue
                    this.updateTchDirect({tchForm: {tchId: row.id, hr: newValue}})
                  }
                }
              }
            }, options.map(item => {
              return h('Option', {props: {value: item.code}, key: item.code}, item.text)
            }))
          }
        },
        {
          title: '推荐人说明',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.inviteRemark || ''  // 添加title属性显示完整内容
              },
              props: {
                value: row.inviteRemark,
                placeholder: 'remark',
                type: 'textarea',
                autosize: {
                  minRows: 1,
                  maxRows: 3
                }
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.inviteRemark) {
                    row.inviteRemark = newValue
                    this.updateTchDirect({tchForm: {tchId: row.id, inviteRemark: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.inviteRemark) {
                    row.inviteRemark = value
                    this.updateTchDirect({tchForm: {tchId: row.id, inviteRemark: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '开课时间',
          width: 180,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('DatePicker', {
              props: {
                type: 'date',
                format: 'yyyy-MM-dd',
                value: row.openCourseTime,
                placeholder: '选择日期',
                transfer: true
              },
              on: {
                'on-change': (value) => {
                  if (value !== row.openCourseTime) {
                    row.openCourseTime = value
                    this.updateTchDirect({tchForm: {tchId: row.id, openCourseTime: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '注册渠道',
          width: 100,
          align: 'center',
          key: 'regFrom'
        },
        {
          title: '类型',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let category = params.row.category
            let categoryEnum = $constant.getEnum($constant.teacherCategory, category)
            return h('span', categoryEnum && categoryEnum.text)
          }
        },
        {
          title: '应急外教',
          width: 110,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Select', {
              props: {
                value: row.emergency,
                transfer: true
              },
              on: {
                'on-change': (value) => {
                  // 更新数据
                  row.emergency = value
                  this.updateTchDirect({tchList: {id: row.id, emergency: value}})
                }
              }
            }, [
              h('Option', {props: {value: 1}}, '是'),
              h('Option', {props: {value: 0}}, '否')
            ])
          }
        },
        {
          title: '转正时间',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.regularTime || ''  // 添加title属性显示完整内容
              },
              props: {
                value: row.regularTime,
                placeholder: '1900-06-01'
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.regularTime) {
                    row.regularTime = newValue
                    this.updateTchDirect({tchForm: {tchId: row.id, regularTime: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.regularTime) {
                    row.regularTime = value
                    this.updateTchDirect({tchForm: {tchId: row.id, regularTime: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '优秀外教',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Select', {
              props: {
                value: row.excellent,
                transfer: true
              },
              on: {
                'on-change': (value) => {
                  // 更新数据
                  row.excellent = value
                  this.updateTchDirect({tchForm: {tchId: row.id, excellent: value}})
                }
              }
            }, this.excellentOptions.map(item => {
              return h('Option', {props: {value: item}}, item)
            }))
          }
        },
        {
          title: '合同版本',
          key: 'contractVersion',
          width: 120,
          align: 'center',
        },
        {
          title: '绑定权限',
          width: 110,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Select', {
              props: {
                value: row.isCanBound,
                transfer: true
              },
              on: {
                'on-change': (value) => {
                  // 更新数据
                  row.isCanBound = value
                  this.updateTchDirect({tchList: {id: row.id, isCanBound: value}})
                }
              }
            }, this.$constant.yesNoNum.map(item => {
              return h('Option', {props: {value: item.code}}, item.text)
            }))
          }
        },
        {
          title: '临时约课权限',
          width: 110,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Select', {
              props: {
                value: row.tempSchedule,
                transfer: true
              },
              on: {
                'on-change': (value) => {
                  // 更新数据
                  row.tempSchedule = value
                  this.updateTchDirect({tchList: {id: row.id, tempSchedule: value}})
                }
              }
            }, this.$constant.yesNoNum.map(item => {
              return h('Option', {props: {value: item.code}}, item.text)
            }))
          }
        },
        {
          title: '试听权限',
          width: 110,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Select', {
              props: {
                value: row.isAudition,
                transfer: true
              },
              on: {
                'on-change': (value) => {
                  // 更新数据
                  row.isAudition = value
                  this.updateTchDirect({tchList: {id: row.id, isAudition: value}})
                }
              }
            }, this.$constant.yn.map(item => {
              return h('Option', {props: {value: item.code}}, item.text)
            }))
          }
        },
        {
          title: '性别',
          width: 110,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Select', {
              props: {
                value: row.sex,
                transfer: true
              },
              on: {
                'on-change': (value) => {
                  // 更新数据
                  row.sex = value
                  this.updateTchDirect({tchList: {id: row.id, sex: value}})
                }
              }
            }, this.$constant.sex.map(item => {
              return h('Option', {props: {value: item.code}}, item.text)
            }))
          }
        },
        {
          title: '口音',
          width: 110,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Select', {
              props: {
                value: row.accent,
                transfer: true
              },
              on: {
                'on-change': (value) => {
                  // 更新数据
                  row.sex = value
                  this.updateTchDirect({tchInfo: {tchId: row.id, accent: value}})
                }
              }
            }, this.$constant.accent.map(item => {
              return h('Option', {props: {value: item.code}}, item.text)
            }))
          }
        },
        {
          title: '进度',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.progressRemark || ''  // 添加title属性显示完整内容
              },
              props: {
                value: row.progressRemark,
                placeholder: 'remark',
                type: 'textarea',
                autosize: {
                  minRows: 1,
                  maxRows: 3
                }
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.progressRemark) {
                    row.progressRemark = newValue
                    this.updateTchDirect({tchForm: {tchId: row.id, progressRemark: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.progressRemark) {
                    row.progressRemark = value
                    this.updateTchDirect({tchForm: {tchId: row.id, progressRemark: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '周末时间',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.weekendRemark || ''  // 添加title属性显示完整内容
              },
              props: {
                value: row.weekendRemark,
                placeholder: 'remark',
                type: 'textarea',
                autosize: {
                  minRows: 1,
                  maxRows: 3
                }
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.weekendRemark) {
                    row.weekendRemark = newValue
                    this.updateTchDirect({tchForm: {tchId: row.id, weekendRemark: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.weekendRemark) {
                    row.weekendRemark = value
                    this.updateTchDirect({tchForm: {tchId: row.id, weekendRemark: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '期望时薪',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.expectSalary || ''  // 添加title属性显示完整内容
              },
              props: {
                value: row.expectSalary,
                placeholder: '期望时薪'
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.expectSalary) {
                    row.expectSalary = newValue
                    this.updateTchDirect({tchForm: {tchId: row.id, expectSalary: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.expectSalary) {
                    row.expectSalary = value
                    this.updateTchDirect({tchForm: {tchId: row.id, expectSalary: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '试用期时薪',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.probationHourlySalary || ''  // 添加title属性显示完整内容
              },
              props: {
                value: row.probationHourlySalary,
                placeholder: '试用期时薪'
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.probationHourlySalary) {
                    row.probationHourlySalary = newValue
                    this.updateTchDirect({tchForm: {tchId: row.id, probationHourlySalary: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.probationHourlySalary) {
                    row.probationHourlySalary = value
                    this.updateTchDirect({tchForm: {tchId: row.id, probationHourlySalary: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '试用期课薪',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.probationClassSalary || ''  // 添加title属性显示完整内容
              },
              props: {
                value: row.probationClassSalary,
                placeholder: '试用期课薪'
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.probationClassSalary) {
                    row.probationClassSalary = newValue
                    this.updateTchDirect({tchForm: {tchId: row.id, probationClassSalary: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.probationClassSalary) {
                    row.probationClassSalary = value
                    this.updateTchDirect({tchForm: {tchId: row.id, probationClassSalary: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '转正时薪',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.regularHourlySalary || ''  // 添加title属性显示完整内容
              },
              props: {
                value: row.regularHourlySalary,
                placeholder: '转正时薪'
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.regularHourlySalary) {
                    row.regularHourlySalary = newValue
                    this.updateTchDirect({tchForm: {tchId: row.id, regularHourlySalary: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.regularHourlySalary) {
                    row.regularHourlySalary = value
                    this.updateTchDirect({tchForm: {tchId: row.id, regularHourlySalary: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '转正课薪',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.regularClassSalary || ''  // 添加title属性显示完整内容
              },
              props: {
                value: row.regularClassSalary,
                placeholder: '转正课薪'
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.regularClassSalary) {
                    row.regularClassSalary = newValue
                    this.updateTchDirect({tchForm: {tchId: row.id, regularClassSalary: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.regularClassSalary) {
                    row.regularClassSalary = value
                    this.updateTchDirect({tchForm: {tchId: row.id, regularClassSalary: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '证书',
          key: 'certs',
          width: 120,
          align: 'center',
        },
        {
          title: '最高学历',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.eduLevel || ''  // 添加title属性显示完整内容
              },
              props: {
                value: row.eduLevel,
                placeholder: '最高学历'
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.eduLevel) {
                    row.eduLevel = newValue
                    this.updateTchDirect({tchList: {id: row.id, eduLevel: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.eduLevel) {
                    row.eduLevel = value
                    this.updateTchDirect({tchList: {id: row.id, eduLevel: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '备注',
          width: 300,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.remark || '',  // 添加title属性显示完整内容
                rows: 3  // 默认显示3行
              },
              props: {
                value: row.remark,
                placeholder: 'remark',
                type: 'textarea'
              },
              style: {
                resize: 'vertical'  // 允许垂直方向调整大小
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.remark) {
                    row.remark = newValue
                    this.updateTchDirect({tchInfo: {tchId: row.id, remark: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.remark) {
                    row.remark = value
                    this.updateTchDirect({tchInfo: {tchId: row.id, remark: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '合同开始时间',
          key: 'crtBeginTime',
          width: 120,
          align: 'center',
        },
        {
          title: '合同结束时间',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let day = row.crtEndTimeDay
            let crtEndTime = row.crtEndTime
            if (crtEndTime) {
              if (day <= 30) {
                return h('div', [
                  h('p', {}, row.crtEndTime),
                  h('span', {style: {color: 'red'}}, '距结束' + day + '天')
                ])
              } else {
                return h('div', [
                  h('p', {}, row.crtEndTime),
                ])
              }
            }
          }
        },
        {
          title: '注册时间',
          width: 120,
          align: 'center',
          key: 'createTime'
        },
        {
          title: '邮箱',
          width: 150,
          align: 'center',
          render: (h, params) => {
            return h('Poptip', {
              props: {
                trigger: 'hover'
              }
            }, [
              h('span', {}, params.row.email),
              // 当前行展示的数据
              h('div', {slot: 'content'}, params.row.email)
            ])
          }
        },
        {
          title: '生日',
          width: 150,
          align: 'center',
          key: 'birthday'
        },
        {
          title: '账号/classin账号',
          width: 250,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              props: {
                value: row.account,
                placeholder: 'Login Account'
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.account) {
                    row.account = newValue
                    this.updateTchDirect({tchList: {id: row.id, account: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.account) {
                    row.account = value
                    this.updateTchDirect({tchList: {id: row.id, account: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '时差(小时)',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              props: {
                value: row.timeDiff,
                placeholder: '正负数字'
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.timeDiff) {
                    row.timeDiff = newValue
                    this.updateTchDirect({tchInfo: {tchId: row.id, timeDiff: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.timeDiff) {
                    row.timeDiff = value
                    this.updateTchDirect({tchInfo: {tchId: row.id, timeDiff: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '专业',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              props: {
                value: row.major,
                placeholder: '大学专业'
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.major) {
                    row.major = newValue
                    this.updateTchDirect({tchForm: {tchId: row.id, major: newValue}})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.major) {
                    row.major = value
                    this.updateTchDirect({tchForm: {tchId: row.id, major: value}})
                  }
                }
              }
            })
          }
        },
        {
          title: '展示邀请海报',
          width: 110,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Select', {
              props: {
                value: row.showPoster,
                transfer: true
              },
              on: {
                'on-change': (value) => {
                  // 更新数据
                  row.showPoster = value
                  this.updateTchDirect({tchForm: {tchId: row.id, showPoster: value}})
                }
              }
            }, this.$constant.yesNoNum.map(item => {
              return h('Option', {props: {value: item.code}}, item.text)
            }))
          }
        },
        {
          title: '最近跟踪',
          width: 170,
          align: 'center',
          render: (h, params) => {
            let trackTime = params.row.trackTime
            let trackContent = params.row.trackContent
            return h('div', [
              h('div', {
                attrs: {
                  title: trackContent // 鼠标悬停时显示完整内容
                },
                style: {
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }
              }, trackContent || ''),
              h('div', {
                style: {
                  fontSize: '12px',
                  color: '#999',
                  marginTop: '4px'
                }
              }, trackTime || '')
            ])
          }
        },
        {
          title: '操作',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('div', [
              h('a', {
                on: {
                  click: () => {
                    this.onSendEmail(row)
                  }
                }
              }, '发送邮件')
            ])
          }
        }
      ]
    }
  },
  mounted: function () {
    this.loadRegChannels()
    let self = this
    let queryParam = this.queryParam
    queryParam.uid = this.$route.query.uid

    this.$http.post('/adminUser/listByCondition', {adminGroupId: 7, status: 1}).then(function (res) {
      if (!res || !res.data) {
        return
      }
      self.studyAdviserList = res.data
    })
  },

  methods: {
    loadRegChannels () {
      let self = this
      this.$http.get('/tch/reg-channel/options').then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          self.channelOptions = res.data
        }
      })
    },
    onSendEmail (row) {
      this.emailTchId = row.id
      this.emailTchName = row.firstName + ' ' + row.lastName
      this.showEmailModal = true
    },
    updateTchDirect (req) {
      this.$http.post('/tch/update-direct', req).then(res => {
        if (res.status === 'ok') {
          this.$Message.success('更新成功')
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(() => {
        this.$Message.error('更新失败')
      })
    },
    onReject (row) {
      this.showRejectModal = true
      this.rejectParam.id = row.id
      this.rejectParam.firstName = row.firstName
      this.rejectParam.lastName = row.lastName
      this.passParam.remark = ''
    },
    reject () {
      let self = this
      self.loadingReject = true
      self.$refs.rejectForm.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          self.loadingReject = false
          return
        }
        let params = {}
        params.id = self.rejectParam.id
        params.remark = self.rejectParam.remark
        self.$http.post('/tch/reject', params).then(function (res) {
          if (res && res.data > 0) {
            self.search()
            self.showRejectModal = false
          }
          self.loadingReject = false
        }).catch(function (e) {
          self.showRejectModal = false
          self.loadingReject = false
        })
      })
    },
    openTchInfoModal (val) {
      this.tchId = val
      this.showTchInfoModal = true
    },

    closeModal (val) {
      this.uid = null
      this.editUser = val
    },

    search () {
      this.reload = new Date().getTime()
    },

    searchWithPage () {
      this.reloadWithPage = new Date().getTime()
    },

    onLoading (loading) {
      this.searchLoading = loading
      if (!loading) {
        this.loadMonthRankScores()
      }
    },
    loadMonthRankScores () {
      const table = this.$refs.dataList && this.$refs.dataList.tableData
      if (!table || !table.length) {
        return
      }
      const ids = table.map(function (row) { return row.id }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, table, 'id', 'monthRankScore', map)
      })
    },

    onTchChangeStatusList (tchId) {
      let self = this
      self.tchChangeStatusList = []
      self.$http.get('/tchChangeStatus/listByCondition?tchId=' + tchId).then(function (res) {
        self.showTchChangeModal = true
        if (!res || !res.data) {
          return
        }
        self.tchChangeStatusList = res.data.filter(function (item) {
          return item.type === 4
        })
      })
    },

    selectionChange (selection) {
      this.selectionTch = selection
    },

    // 分配外教运营
    onAssignAdviser () {
      if (this.selectionTch.length <= 0) {
        this.$Message.warning('请选择需分配外教运营的老师！')
        return
      }
      this.showAssignTchStudyAdviserModal = true
    },
    batchReject () {
      let self = this
      if (self.selectionTch.length <= 0) {
        self.$Message.warning('请选择老师！')
        return
      }
      this.showBatchReviewModal = true
    },


    closeEditDingModal () {
      this.showEditDingModal = false
      this.tchId = null
    },

    closeTeacherDingTalkModal () {
      this.showTeacherDingTalkModal = false
      this.tchId = null
    },
    exportData () {
      this.exportLoading = true
      this.$http({
        method: 'post',
        url: '/tchList/normal-list-export',
        data: this.queryParam,
        responseType: 'arraybuffer'
      }).then((response) => {
        if (response.data) {
          let blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '在职老师.xlsx'
          link.click()
          this.exportLoading = false
        } else {
          this.$Message.error(response.msg || '导出失败')
        }
      }).catch((e) => {
        this.$Message.error('导出失败')
        this.exportLoading = false
      })
    },
    atimeDateChange (value) {
      this.queryParam.startOpenCourseDate = value[0]
      this.queryParam.endOpenCourseDate = value[1]
    },
    createDateChange (value) {
      this.queryParam.startCreateDate = (value && value[0]) || ''
      this.queryParam.endCreateDate = (value && value[1]) || ''
      this.search()
    },
  },

  watch: {}
}
</script>

<style scoped>
.list {
  padding: 0;
}

.breadcrumb {
  margin-bottom: 10px;
}

.search {
  margin-bottom: 16px;
}

.search /deep/ .ivu-form-item {
  margin-bottom: 12px;
}

.search /deep/ .ivu-form-item-label {
  float: none;
  display: block;
  width: auto !important;
  text-align: left;
  padding: 0 0 6px;
  line-height: 1.4;
}

.search /deep/ .ivu-form-item-content {
  margin-left: 0 !important;
}

.search /deep/ .ivu-select,
.search /deep/ .ivu-input-wrapper,
.search /deep/ .ivu-date-picker {
  width: 100%;
}

.search-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
</style>



// WEBPACK FOOTER //
// TchNormalList.vue?96f7bb00